import { version } from '@phi/constants';
import { Module } from './interface';

/** load jcore.js from the public directory */
export const load_module = (): Promise<Error|Module> => new Promise(done => {
    const Module = {
        onRuntimeInitialized: () => done(Module)
    } as any as Module;

    fetch(`/_phi_core.js?${version}`)
        .then(x => x.text())
        .then(x => x.replace(
            // this forcefully invalidates the cache if we have a new app version :)
            'fetch(wasmBinaryFile',
            `fetch(wasmBinaryFile + '${version}'`,
        ))
        .then(x => {
            // jcore.js mutates the global Module object as per emscripten conventions.
            // immediately after evaluation, the core attempts to initialise,
            // and calls the `onRuntimeInitialised` callback when it is done.
            // instead of relying on that, we wrap the file around a function,
            // and call the function with a module object of our choosing
            // (dependency injection)
            eval(`(function (Module) {\n${x}\n})`)(Module);
        })
        .catch(() => {
            done(new Error());
        });
});
